
<div :class="['spinner-container', { inline, light }]">
  <span class="spinner" :style="{ width: `${this.size}px`, height: `${this.size}px` }" />
</div>
